import {Drawable} from "./Drawable";
import {PanTool} from "./PanTool";
import {SelectTool} from "./SelectTool";
import {ConnectTool} from "./ConnectTool";

const HEIGHT = 24;

export class Toolbar extends Drawable{

	constructor(editor) {
		super();
		this.editor = editor;
		this.tools = [];
		this.tools.push(new ToolItem("tool-select", new SelectTool()));
		this.tools.push(new ToolItem("tool-pan", new PanTool()));
		this.tools.push(new ToolItem("tool-connect", new ConnectTool()));
		this.tools.push(new SpacerItem());
		this.tools.push(new ActionItem("tool-zoomin", editor.zoomIn.bind(editor)));
		this.tools.push(new ActionItem("tool-zoomout", editor.zoomOut.bind(editor)));
		this.tools.push(new ToolItem("tool-center", new PanTool()));
		this.tools.push(new SpacerItem());
		this.tools.push(new ObjectItem("tool-task", editor, "task", this));
		this.tools.push(new ObjectItem("tool-call", editor, "call", this));
		this.tools.push(new ObjectItem("tool-gateway", editor, "gateway", this));
		this.tools.push(new ObjectItem("tool-start", editor, "start", this));
		this.tools.push(new ObjectItem("tool-event", editor, "event", this));
		this.tools.push(new ObjectItem("tool-end", editor, "end", this));
		this.tools.push(new ObjectItem("tool-swimlane", editor, "swimlane", this));

		this.tools.push(new SpacerItem());
		this.tools.push(new ToggleItem("tool-props", editor.displayProps.bind(editor)));
		this.selected = 0;
	}

	draw(ctx) {
		ctx.save();
		const w = ctx.canvas.width;
		ctx.fillStyle = S.BASE_COLORS[16];
		ctx.fillRect(0, 0, w, HEIGHT);
		ctx.lineWidth = 1;
		ctx.strokeStyle = S.BASE_COLORS[14];
		ctx.beginPath();
		ctx.moveTo(0, HEIGHT + 0.5);
		ctx.lineTo(w, HEIGHT + 0.5);
		ctx.stroke();

		let x = 8, y = 3;
		for (let i = 0; i < this.tools.length; i++) {
			const t = this.tools[i];
			const selected = i === this.selected;

			x = t.draw(ctx, x, y, selected);
			x += 8;
		}
		ctx.restore();
	}

	/**
	 * @return {Tool}
	 */
	get currentTool() {
		return this.tools[this.selected].tool;
	}

	in(e) {
		return e.offsetY <= HEIGHT;
	}

	mouseDown(e) {
		for (let i = 0; i < this.tools.length; i++) {
			const t = this.tools[i];
			if (t.isHover(e.offsetX, e.offsetY)) {
				if (t.selectable) {
					const oldSelected = this.selected;
					this.selected = i;
					const toolChanged =  this.selected !== oldSelected;
					if (toolChanged) this.editor.toolChanged();
					return toolChanged;
				} else if (typeof t.doAction === 'function') {
					t.doAction(e.offsetX, e.offsetY);
					return true;
				}
			}
		}
		return false;
	}

	mouseUp(e) {
		return false;
	}

	mouseMove(e) {
		let wasChange = false;
		for (let t of this.tools) {
			const wasHover = t.hover;
			const isHover = t.setHover(e.offsetX, e.offsetY);
			wasChange = wasChange || (wasHover === isHover);
		}
		return wasChange;
	}
}



class ToolbarItem {
	constructor() {
		this.hover = false;
	}

	get selectable() {
		return false;
	}

	draw(ctx, x, y, selected) {
	}

	setHover(x, y) {
		return this.hover = this.isHover(x, y);
	}

	isHover(x, y) {
		return false;
	}
}


class IconItem extends ToolbarItem {

	constructor(id) {
		super();
		this.id = id;
	}

	draw(ctx, x, y, selected) {
		const img = document.getElementById(this.id+(selected ? "-sel" : (this.hover ? "-hov" : "")));
		ctx.drawImage(img, x, y, 18, 18);
		this.x = x;
		this.y = y;
		return x+18;
	}

	isHover(x, y) {
		return (x >= this.x && x < this.x + 18) && (y >= this.y && y < this.y + 18);
	}
}


class ToolItem extends IconItem {
	constructor(id, tool) {
		super(id);
		this.tool = tool;
	}

	get selectable() {
		return true;
	}
}

class ActionItem extends IconItem {
	constructor(id, action) {
		super(id);
		this.action = action;
	}

	doAction(x, y) {
		this.action(x, y);
	}
}

class ObjectItem extends ActionItem {
	constructor(id, editor, objectType, toolbar) {
		super(id, null);
		this.editor = editor;
		this.action = this.placeObject.bind(this);
		this.toolbar = toolbar;
		this.type = objectType;
	}

	placeObject(x, y) {
		this.toolbar.selected = 0;	// select tool
		const manipulable = this.editor.newObject(this.type, x, y);
		if (manipulable) {
			const evt = { offsetX: x, offsetY: y };
			this.toolbar.currentTool.mouseDown(evt, this.editor.canvas);
		}
	}
}

class ToggleItem extends ActionItem {
	constructor(id, action) {
		super(id, action);
	}

	doAction(x, y) {
		const oldState = this.action();
		if (oldState) this.action(false);
		else this.action(true);
	}


	draw(ctx, x, y, selected) {
		if (this.action()) {
			ctx.fillStyle = S.BASE_COLORS[12];
			ctx.fillRect(x - 1, y - 1, 20, 20);
		}
		return super.draw(ctx, x, y, selected);
	}
}

class SpacerItem extends ToolbarItem {
	constructor() {
		super();
	}


	draw(ctx, x, y, selected) {
		ctx.save();
		ctx.lineWidth = 1;
		ctx.strokeStyle = S.BASE_COLORS[12];
		ctx.beginPath();
		ctx.moveTo(x + 5.5, y);
		ctx.lineTo(x + 5.5, y + 18);
		ctx.stroke();
		ctx.restore();
		return x+11;
	}
}